<template>
  <el-dialog
    class="upload-resource"
    :visible.sync="dialogShow"
    width="600px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    append-to-body
    :before-close="close"
  >
    <div slot="title">
      <div class="title">{{ edit ? '编辑资料' : '上传资料'}}</div>
    </div>
    <div>
      <el-form :model="resourceForm" :rules="rules" ref="resourceForm" label-width="80px" label-position="left">
        <el-form-item v-if="!edit" label="上传文件" prop="url">
          <el-upload
            v-loading="uploading"
            drag
            action
            accept=".pdf"
            ref="upload"
            :http-request="handleUpload"
            :multiple="false"
            :on-change="handleChange"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :on-error="handleUploadFail"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
          >
            <div class="el-upload__text">
              <em>上传资料</em>，仅支持pdf格式
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-else label="上传文件" prop="url">
          <div class="flex align-items-center" style="height: 40px;">
            <span class="mr-sm">{{ upload_file_name }}</span>
            <el-upload
              v-loading="uploading"
              action
              accept=".pdf"
              ref="upload"
              :http-request="handleUpload"
              :show-file-list="false"
              :multiple="false"
              :on-change="handleChange"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :on-error="handleUploadFail"
              :on-success="handleUploadSuccess"
              :on-remove="handleRemove"
            >
              <el-button  type="text">重新上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="资料名称" prop="title">
          <el-input v-model="resourceForm.title" clearable></el-input>
        </el-form-item>
        <el-form-item label="生效范围" prop="effect_scope">
          <el-radio-group v-model="resourceForm.effect_scope" @change="handleScopeChange">
            <el-radio :label="1">不指定设备</el-radio>
            <el-radio :label="2">所有设备</el-radio>
            <el-radio :label="3">指定范围</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="margin-left: 80px; margin-top: -20px;" class="mb-md text-success">
          <span role="button" @click="handlePreview">查看示例</span>
        </div>
        <el-form-item v-if="resourceForm.effect_scope == 2 || resourceForm.effect_scope == 3" label="查看权限" prop="auth_level">
          <el-select v-model="resourceForm.auth_level" ref="selectAuthLevel" key="auth_level" clearable placeholder="选择权限" style="width: 100%;">
            <el-option v-for="item in authArr" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceForm.effect_scope == 3" label="选择模型" prop="effect_devids">
          <el-select
            v-model="resourceForm.effect_devids"
            filterable
            :filter-method="filterMethod"
            ref="selectDev"
            key="effect_devids"
            @change="handleSelectChange"
            multiple
            placeholder="请选择模型">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceForm.effect_scope == 3" label="选择商品" prop="effect_productids">
          <el-select
            v-model="resourceForm.effect_productids"
            filterable
            ref="selectProduct"
            key="effect_productids"
            @change="handleSelectChange"
            multiple
            placeholder="请选择商品"
          >
            <el-option v-for="item in products" :key="item.productid" :label="item.title" :value="item.productid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="允许分享" prop="is_allow_share">
          <el-switch v-model="resourceForm.is_allow_share" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="允许下载" prop="is_allow_download">
          <el-switch v-model="resourceForm.is_allow_download" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="flex-center">
      <el-button plain @click="dialogShow = false">取消</el-button>
      <el-button type="primary" :disabled="uploading" @click="submit()">提交</el-button>
    </div>

    <el-image v-show="false" ref="previewImageId" :src="previewUrl" :preview-src-list="[ previewUrl ]" />
  </el-dialog>
</template>

<script>
import { resourcePreUploadApi, resourceUploadFinishApi, resourceUpdateApi } from "@/api/fam/famGodApi";
import { eiProductGetallApi } from "@/api/ei/eiMallApi";

import { getAllDevApi } from "@/api/dev/devApi";
import { decrypt } from "@/utils/common";

import OSS from "ali-oss";

export default {
  name: "UploadResource",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      previewUrl: require('@/assets/resource-example.jpg'),
      loading: false,
      fileList: [],
      resourceForm: {
        url: "",
        title: "",
        effect_scope: 1,
        is_allow_share: 0,
        is_allow_download: 0,
        auth_level: 1,
        effect_devids: [],
        effect_productids: [],
      },
      rules: {
        url: [{ required: true, message: "请上传资料", trigger: "blur" }],
        title: [{ required: true, message: "请输入资料名称", trigger: "blur" }],
        auth_level: [{ required: true, message: "请选择权限", trigger: ["blur", "change"] }],
      },
      uploading: false,
      page_num: 0,
      file_size: 0,
      code: "",
      devs: [],
      options: [],
      products: [],
      upload_file_name: "",
      resourceid: "",
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    godid() {
      return this.$store.state.godStore.godid;
    },
    authArr() {
      return this.$store.state.userStore.is_frippler ? this.$store.state.rmsStore.authArr : this.$store.state.rmsStore.authArr.slice(0, 6);
    },
  },
  
  watch: {
    "resourceForm.url"() {
      if (this.resourceForm.url && !this.edit) {
        // this.$refs["resourceForm"].clearValidate(["visibleFileUrl"]); //清除提示
        this.$refs.resourceForm.validateField("url"); //或者校验某个字段  二者选其一
      }
    },
  },

  created() {
    this.fetchData();
    this.fetchProduct();
    
    if (this.edit) {
      this.resourceForm = Object.assign({}, this.resourceForm,{
        url: this.resource.url,
        title: this.resource.title,
        effect_scope: this.resource.effect_scope,
        is_allow_share: this.resource.is_allow_share,
        is_allow_download: this.resource.is_allow_download,
        auth_level: this.resource.auth_level ? this.resource.auth_level : '',
        effect_devids: this.resource.devs && this.resource.devs.length 
          ? this.resource.effect_devids.map((item) => {
              return Number(item);
            })
          : [],
        effect_productids: this.resource.products && this.resource.products.length 
          ? this.resource.effect_productids.map((item) => {
              return Number(item);
            })
          : [],
      });
      this.resourceid = this.resource.resourceid;
      this.upload_file_name = this.resourceForm.title + '.pdf';
      this.file_size = this.resource.file_size;
      this.page_num = this.resource.page_num;
    }
  },

  methods: {
    handlePreview() {
      this.$nextTick(() => {
        this.$refs['previewImageId'].clickHandler()
      })
    },

    fetchProduct() {
      eiProductGetallApi().then((res) => {
        if (!res.errno) {
          this.products = res.data.list
        }
      });
    },
    
    fetchData() {
      getAllDevApi().then((res) => {
        if (!res.errno) {
          this.options = res.data.list.map((item) => {
            return {
              value: item.devid,
              label: item.dev_name,
            };
          });
          this.devs = this.options;
        }
      });
    },

    filterMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.options.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = this.devs;
        this.$refs.selectDev.blur();
      }
    },
    handleScopeChange() {
      // this.resourceForm.effect_productids = []
      // this.resourceForm.effect_devids = []
      if (this.$refs.selectDev) this.$refs.selectDev.blur()
      if (this.$refs.selectProduct) this.$refs.selectProduct.blur()
    },
    handleSelectChange(value) {
    },
    submit() {
      this.$refs["resourceForm"].validate((valid) => {
        if (valid) {
          const temp = {
            ...this.resourceForm,
            godid: this.godid,
            file_size: this.file_size,
            page_num: this.page_num,
            code: this.code,
          };
          // if (this.resourceForm.effect_scope != 3) {
          //   temp.effect_devids = [];
          // }
          // if (this.resourceForm.effect_scope != 4) {
          //   temp.effect_productids = [];
          // }
          if (this.edit) {
            delete temp.godid;
            delete temp.code;
            temp.resourceid = this.resourceid;
          }

          resourceUpdateApi(temp).then((res) => {
            if (!res.errno) {
              this.$message.success("上传成功");
              this.dialogShow = false;
              this.$emit("change");
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    handleChange(file, fileList) {
      this.file_size = file.size;
      if (fileList.length > 1) {
        this.fileList = fileList.slice(-1);
      } else {
        this.fileList = fileList;
      }
    },

    beforeUpload(file) {
      const formatArr = ['application/pdf']
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error('上传资料格式只支持 PDF！')
        return false
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error('上传资料大小不能超过 20M！')
        return false
      }
      this.uploading = true;
      return true;
    },

    handleUploadFail(err, file, fileList) {
      this.uploading = false;
      this.$message.error("文件上传失败");
    },

    handleUploadSuccess(response, file, fileList) {
    },

    handleUpload(option) {
      this.uploading = true;
      const that = this;
      if (option.file) {
        const suffix = option.file.name.substring(
          option.file.name.lastIndexOf(".")
        );
        let pointIdx = option.file.name.lastIndexOf(".");
        let filename = ''
			  if (pointIdx > 0) filename = option.file.name.substring(0, pointIdx)
        resourcePreUploadApi({ resourceid: this.edit ? this.resourceid : '' }).then((res) => {
          if (!res.errno) {
            const authdata = JSON.parse(decrypt(res.data));
            
            const ossClient = new OSS({
              accessKeyId: authdata.access_key_id,
              accessKeySecret: authdata.access_key_secret,
              bucket: authdata.bucket,
              region: authdata.region,
              stsToken: authdata.security_token,
              cname: authdata.cname,
              secure: authdata.secure,
              endpoint: authdata.endpoint,
            });
            const code = authdata.code;
            that.code = code;
            const name = authdata.filedir + authdata.filename + suffix;
            const headers = option.headers || {};
            const options = {
              // 设置并发上传的分片数量。
              parallel: 4,
              // 设置分片大小。默认值为1 MB，最小值为100 KB。
              partSize: 1024 * 1024,
              headers: {
                ...headers,
              },
              mime: option.file.type,
            };
            const upload_url =
              `http${authdata.secure ? "s" : ""}://` +
              authdata.endpoint +
              "/" +
              name;
            that.resourceForm.url = upload_url;

            ossClient
              .multipartUpload(name, option.file, {
                ...options,
              })
              .then((result) => {
                const finish_params = {
                  url: upload_url,
                  code: code,
                };
                resourceUploadFinishApi(finish_params).then((resp) => {
                  this.uploading = false;
                  if (!resp.errno) {
                    that.upload_file_name = filename
                    that.resourceForm.title = filename
                    that.page_num = resp.data.page_num;
                  } else {
                    that.$message.error(resp.message);
                  }
                });
              });
          }
        });
      }
    },

    handleRemove(file, fileList) {
      this.resourceForm.url = "";
    },

    getSuffix(str) {
      return str.substring(str.lastIndexOf("."));
    },

    closeDialog() {
      this.dialogShow = false;
      this.$emit("change");
    },

    close() {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-resource {
  .title {
    font-size: 20px;
  }
  /deep/ .el-dialog__body {
    padding: 30px;
  }
  /deep/ .el-upload {
    width: 100%;
    .el-upload-dragger {
      display: flex;
      align-items: center;
      width: 100%;
      height: 48px;
      font-size: 14px;
      text-align: center;
      .el-upload__text {
        width: 100%;
      }
    }
  }
  /deep/ .el-select {
    width: 100%;
  }
  
}
/deep/.demo-image {
  width: 800px;
  height: 600px;
}
</style>
<style lang="scss">
.el-popper.resource-demo {
  padding: 0px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  .popper__arrow {
    display: none;
  }
}
</style>